<div class="absolute top-0 left-0 z-10 flex h-full w-full items-center justify-center">
    <div class="flex flex-col items-center justify-center gap-4 bg-body-popup shadow rounded p-4">
        <div class="flex gap-2 items-center px-6 py-4">
            @if (!loading) {
                <bizz-icon iconName="circle-info" class="min-h-8 min-w-8 size-8 text-blue-500/90"></bizz-icon>
            }
            @if (mode() == 'save') {
                <p class="text-default/90 text-sm"> {{ 'ExecuteChecklistRequiresSave' | translate }}</p>
            } @else if (!loading() && mode() == 'select') {
                <p class="text-default/90 text-sm"> {{ 'Info_ChooseATemplateFromTheTemplateCollection' | translate }}</p>
            }@else if (!loading() && mode() == 'invalidChecklistsLicense') {
                <p class="text-default/90 text-sm"> {{ 'NoChecklistsLicense' | translate }}</p>
            }
            @else if (loading()) {
                <svg class="animate-spin fill-current text-default size-7" xmlns="http://www.w3.org/2000/svg"
                     height="1em" viewBox="0 0 512 512">
                    <defs>
                        <style>.fa-secondary {
                            opacity: 0.4;
                        }</style>
                    </defs>
                    <path class="fa-primary" d="M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3
          128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7
          0-32-14.3-32-32z"/>
                    <path class="fa-secondary" d="M256 64C150 64 64 150 64 256s86 192 192 192c70.1 0 131.3-37.5 164.9-93.6l.1
          .1c-6.9 14.9-1.5 32.8 13 41.2c15.3 8.9 34.9 3.6 43.7-11.7c.2-.3 .4-.6 .5-.9l0 0C434.1 460.1 351.1 512 256
          512C114.6 512 0 397.4 0 256S114.6 0 256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z"/>
                </svg>
                <p class="ml-2 text-default/90 text-sm"> {{ 'LoadingTheQuestions' | translate }}...</p>
            }
        </div>
        @if (mode() == 'save' && canSave()) {
            <div class="w-full flex justify-end">
                <button class="form-header-button save" (click)="onSave.emit($event)">
                    <bizz-icon class="h-4 w-4" iconName="circle-check"></bizz-icon>
                    {{ 'Save' | translate }}
                </button>
            </div>
        }
    </div>
</div>
<div class="flex flex-col gap-2">
    <bizz-execute-checklist-question-preview [loading]="loading()"></bizz-execute-checklist-question-preview>
</div>


